<template>
  <vs-row>
    <vs-col vs-w="12" class="p-2">
      <vx-card v-if="leaderboard">
        <sm-hateoas-table
          ref="leaderboardTable"
          :paged-resources="leaderboard"
          :relation="'leaderboard'"
          :pagination="true">
          <template slot="thead">
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.first_name') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.last_name') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.total_referrals') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.accepted_referrals') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.acceptance_rate') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.expired_referrals') }}
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].firstName">
                {{ data[indextr].firstName}}
              </vs-td>
              <vs-td :data="data[indextr].lastName">
                {{ data[indextr].lastName}}
              </vs-td>
              <vs-td :data="data[indextr].totalReferrals">
                {{ data[indextr].totalReferrals}}
              </vs-td>
              <vs-td :data="data[indextr].acceptedReferrals">
                {{ data[indextr].acceptedReferrals}}
              </vs-td>
              <vs-td :data="data[indextr].acceptanceRate">
                {{ data[indextr].acceptanceRate}}%
              </vs-td>
              <vs-td :data="data[indextr].expiredReferrals">
                {{ data[indextr].expiredReferrals}}
              </vs-td>
            </vs-tr>
            </template>
        </sm-hateoas-table>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import SmHateoasTable from '@/components/starling/sm-hateoas-table/sm-hateoas-table';

export default {
  name: 'view-leaderboard',
  components: {
    SmHateoasTable
  },
  props: {
    leaderboardResource: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      leaderboard: this.leaderboardResource
    };
  }
};
</script>
